import { MessagingAdminModule } from './messaging-admin/messaging-admin.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MessagingAdminModule
  ]
})
export class MessagingModule { }
